import React, { createContext, useContext, useState } from "react";
import { ClipLoader , BeatLoader} from "react-spinners";

// 로딩 상태를 저장하는 Context 생성
const LoadingContext = createContext();

// Context를 사용할 수 있도록 하는 Custom Hook
export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
	const [loadingCount, setLoadingCount] = useState(0);
    const [delayedLoading, setDelayedLoading] = useState(false);

    const showLoading = () => {
        setLoadingCount((prev) => prev + 1);
        setDelayedLoading(true);
    };

    const hideLoading = () => {
        setLoadingCount((prev) => {
            if (prev <= 1) {
                setTimeout(() => setDelayedLoading(false), 500); // 0.5초 후 숨김
                return 0;
            }
            return prev - 1;
        });
    };

	return (
        <LoadingContext.Provider value={{ showLoading, hideLoading }}>
            {children}
            {delayedLoading && (
                <div style={styles.overlay}>
                    <BeatLoader size={15} color="#007bff" margin={5} />
                </div>
            )}
        </LoadingContext.Provider>
    );
};

const styles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.38)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
    },
};